import * as React from "react";
import { cn } from "@/lib/utils";

// Ported from careers.co.jp v2 form controls.

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  ({ className, ...props }, ref) => (
    <input
      ref={ref}
      className={cn(
        "h-9 w-full px-3.5 text-[14px] text-text placeholder:text-text-3",
        "rounded-md border border-border bg-surface",
        "focus:outline-2 focus:outline-brand-500 focus:outline focus:outline-offset-1",
        "disabled:cursor-not-allowed disabled:opacity-60",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";

export const Textarea = React.forwardRef<
  HTMLTextAreaElement,
  React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, rows = 3, ...props }, ref) => (
  <textarea
    ref={ref}
    rows={rows}
    className={cn(
      "block w-full rounded-lg border border-border bg-surface px-3.5 py-2.5 text-[14px] text-text placeholder:text-text-3 leading-relaxed resize-none",
      "focus:outline-2 focus:outline-brand-500 focus:outline focus:outline-offset-1",
      "disabled:cursor-not-allowed disabled:opacity-60",
      className,
    )}
    {...props}
  />
));
Textarea.displayName = "Textarea";

export const Label: React.FC<React.LabelHTMLAttributes<HTMLLabelElement>> = ({
  className,
  ...props
}) => (
  <label
    className={cn(
      "block text-[11px] font-semibold uppercase tracking-wide text-text-2 mb-1.5",
      className,
    )}
    {...props}
  />
);

export const Select = React.forwardRef<
  HTMLSelectElement,
  React.SelectHTMLAttributes<HTMLSelectElement>
>(({ className, ...props }, ref) => (
  <select
    ref={ref}
    className={cn(
      "h-9 w-full px-3 text-[14px] text-text rounded-md border border-border bg-surface",
      "focus:outline-2 focus:outline-brand-500 focus:outline focus:outline-offset-1",
      "disabled:cursor-not-allowed disabled:opacity-60",
      className,
    )}
    {...props}
  />
));
Select.displayName = "Select";
